import { filtersHelper } from "@/utils";

export const orderModel = (data = {}) => ({
  uuid: data.uuid,
  orderNo: data.order_no || "",
  totalAmount: data.total_amount ?? "0.00",
  buyer: data.buyer || null,
  buyerUUID: data.buyer?.uuid || "",
  buyerName:
    [data.buyer?.first_name, data.buyer?.last_name].filter(Boolean).join(" ") ||
    data.buyer?.name ||
    "",
  buyerEmail: data.buyer?.email || "",
  statusName: data.order_status?.name || "",
  createdAt: filtersHelper.getDateTimeFormat(data.created_at),
  items: (data.order_details || []).map((detail) => ({
    uuid: detail.product_variation?.uuid || "",
    quantity: detail.quantity,
    price: detail.unit_price,
    amount: detail.amount,
    statusName: detail.order_status?.name || "",
    product: detail.product || null,
    variation: detail.product_variation || null,
  })),
});
